import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompleteRegistrationFlowModel } from "../models/registration-flow/complete-registration-flow.model";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { PendingRegistrationFlowModel } from "../models/registration-flow/pending-registration-flow.model";

@Injectable({
  providedIn: 'root'
})
export class RegistrationFlowService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  completeRegistrationFlow(
    registrationLinkId: string,
    model: CompleteRegistrationFlowModel
  ): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/registration-flow/complete/' + registrationLinkId,
      model
    );
  }

    public getPendingRegistrationFlow(
    ): Observable<PendingRegistrationFlowModel | null> {
    return this.httpClient.get<PendingRegistrationFlowModel | null>(
      Configuration.getApiBaseUrl() + '/registration-flow/pending-registration-flow'
    );
  }
}